import React from "react";
import useAuthToken from "../hooks/useAuthToken";
import useAuthenticatedUser from "../hooks/useAuthenticatedUser";
import {MemoizedUserNavigation} from "../components/sections/Navigation";


export default function UserState() {
    const {auth_token} = useAuthToken()
    const {user_data} = useAuthenticatedUser()

    return (<React.Fragment>
        <MemoizedUserNavigation />
        <div>User data: '{JSON.stringify(user_data)}' (from env: {process.env.REACT_APP_SIGN_IN_USER_DATA})</div>
        <div>Auth Token: '{auth_token}' (from env: '{process.env.REACT_APP_SIGN_IN_USER_AUTH_TOKEN}')</div>
    </React.Fragment>)
}
